import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// Initialize Telegram WebApp
try {
  window.Telegram?.WebApp?.ready();
  window.Telegram?.WebApp?.expand();
} catch {
  // Not in Telegram context (dev mode)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
